import { Alert, Box, Button, Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { VideoModal } from '../Common/VideoModal';
import { CodeTypography } from '../Common/CodeTypography';
import ButtonBack from '../Breadcrumb/ButtonBack';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const RecetaMedicaLayout = () => {

  const onHandleSubmit = async (externalUrl) => {
    if (externalUrl) {
      window.open(externalUrl, '_blank');
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ButtonBack />
        <Card sx={{ p: 1 }}>
          <CardContent sx={{ pb: { xs: 0, sm: 2 } }}>
            <Typography gutterBottom variant='h5' component={'h1'}>
              Nueva Receta Electrónica de Plan Ambulatorio
            </Typography>
            <Typography
              variant='body2'
              color='textSecondary'
              component='p'
              fontWeight='bold'
              gutterBottom
            >
              En esta sección podés confeccionar recetas médicas, firmarlas electrónicamente y
              enviarlas directamente a la farmacia.
            </Typography>
            <VideoModal
              sx={{ pt: 1 }}
              src={'https://www.youtube.com/embed/oXRBIBybkO4?si=yP2Kh4qSchQECR89&autoplay=1'}
            />
            <Alert severity='info' sx={{ mt: 2 }}>
              <Typography variant='body2' color='textSecondary' component='p' gutterBottom>
                <CodeTypography><b>Mi Consultorio</b></CodeTypography>, la plataforma de <b>OSER</b>, está
                integrada con{' '}
                <CodeTypography>
                  <b>MIS RX</b>
                </CodeTypography>
                , lo que te permite acceder a tus <b>Recetas Electrónicas</b> de forma segura, con validez
                legal y el logo oficial de <b>OSER</b>. 
              </Typography>
            </Alert>
          </CardContent>
          <CardActions sx={{ p: 2 }}>
            <Grid container>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2,
                  }}
                >
                  <Button
                    variant='contained'
                    color='primary'
                    startIcon={<OpenInNewIcon />}
                    onClick={(e) =>
                      onHandleSubmit('https://misrx.com.ar/login/sic7f336f53b4dfb9578')
                    }
                  >
                    Ir a Generar Receta
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

export default RecetaMedicaLayout;
